<template>
  <v-dialog
    v-model="internalModal"
    persistent
    max-width="1000"
    :scrollable="true"
  >
    <v-card>
      <v-card-title>
        <v-row>
          <v-col cols="10">
            <v-icon left large color="#0070C0">
              mdi-account-convert
            </v-icon>
            <span>
              Crear Agente
            </span>
          </v-col>
          <v-col
            cols="2"
            style="text-align: end; cursor: pointer;"
            @click="closeModal"
          >
            <v-icon left color="#858C94">
              mdi-close
            </v-icon>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <create-agent
          :personalData="personalData"
          :transforToAgent="transforToAgent"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import CreateAgent from "@/components/commonComponents/forms/CreateAgent.vue";

export default {
  components: {
    CreateAgent,
  },
  props: {
    OpenCreateAgentModal: {
      type: Boolean,
      default: false,
    },
    personalData: Object,
    transforToAgent: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      internalModal: this.OpenCreateAgentModal
    };
  },

  // Sincroniza la prop OpenCreateAgentModal con la variable interna y emite "closeModal" cuando se cierra el modal.
  // Al montar, imprime en consola el estado inicial de OpenCreateAgentModal.
  watch: {
    OpenCreateAgentModal(newVal) {
      this.internalModal = newVal;
    },
    internalModal(newVal) {
      if (!newVal) {
        this.$emit("closeModal");
      }
    }
  },
  mounted() {
    console.log("CreateAgentModal montado, OpenCreateAgentModal =", this.OpenCreateAgentModal);
  },
  methods: {
    closeModal() {
      this.internalModal = false;
    }
  },
};
</script>


